// React-Screen CCustomerDataMode ("Daten des erfassten Kunden") - Strangler
// Phase 5, Klasse B. Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle customerdatamode.js (aus
// lib/scripts/pos/components/CMP_CCustomerDataMode.js).
// Legacy-DOM-Fixture: tests/react-fixtures/CCustomerDataMode.html, gezogen
// aus tests/visual-baseline/26-overlay-kundendaten.html.
//
// Geoeffnet ueber das Kunden-Infoicon (CInfoIcons.customerData), das erst
// nach dem Erfassen eines Kunden freigeschaltet wird; der Aufrufer setzt
// customerId vor draw() und ruft danach drawCustomerData().
//
// reDRAW (nicht reValue): drawCustomerData baut contentText und priceText
// ueber den Builder neu. Der Wert steht danach AUCH in der Klasse, und beide
// Absaetze haengen am ENDE des Elternknotens - in der JSX deshalb als letzte
// zwei Kinder (die IDs :4/:5 kommen aus dem Pfad, nicht aus der Position).
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';

// Legacy-CCaption: innerHTML = value UND class = "CCaption <addclass> <value>".
function Caption({ bridge, path, addclass, value, style }) {
  const cls = 'CCaption' + (addclass ? ' ' + addclass : '') + ' ' + value;
  return <p {...bridge.el(path, 'CCaption')} className={cls} style={style}
            dangerouslySetInnerHTML={{ __html: value }} />;
}

function CustomerDataModeScreen({ bridge }) {
  const t = bridge.t;
  // Legacy: der okButton ist nur OHNE laufenden Bon ein Knopf ("Kunde
  // zuruecknehmen"); mit Bon ist er unsichtbar und ohne Handler.
  const mitBon = bridge.state.mitBon;
  const okButton = bridge.widget('7', 'CPushButton', mitBon
    ? { events: { onMousedown: true, onMouseout: true, onMouseup: true }, proto: CPushButton.prototype }
    : {
      events: { onMousedown: () => bridge.cancelCustomer(), onMouseout: true, onMouseup: true },
      attributes: { onMousedown_parameter_0: bridge.id },
      proto: CPushButton.prototype,
    });
  const backButton = bridge.widget('8', 'CPushButton', {
    events: { onMousedown: () => bridge.cancel(), onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id },
    proto: CPushButton.prototype,
  });

  // Styles, die erst drawCustomerData setzt.
  const contentStyle = bridge.state.datenDa ? { color: '#444444' } : undefined;
  const priceStyle = bridge.state.datenDa
    ? { fontSize: '2.0vh', textAlign: 'right', top: '60px' } : undefined;

  return (
    <>
      {/* wholeOverlay */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame wholeoverlay"
           style={{ position: 'absolute', visibility: 'visible' }}></div>
      {/* overlay */}
      <div {...bridge.el('1', 'CFrame')} className="CFrame overlay" style={{ position: 'absolute' }}></div>
      {/* titleBack */}
      <div {...bridge.el('2', 'CFrame')} className="CFrame titleback" style={{ position: 'absolute' }}></div>
      {/* titleText */}
      <Caption bridge={bridge} path="3" addclass="titletext" value={t('LABELS', 'CUSTOMER_DATA_MODE')}
               style={{ fontSize: '20px' }} />
      {/* unitsText */}
      <Caption bridge={bridge} path="6" addclass="unitstext" value=" " />
      {/* okButton */}
      {mitBon ? (
        <div {...okButton} className="CPushButton okbutton" style={{ visibility: 'hidden' }}>
          <Caption bridge={bridge} path="7:0" addclass="" value=" " />
        </div>
      ) : (
        <div {...okButton} className="CPushButton okbutton" style={{ width: '110px', left: '163px' }}>
          <Caption bridge={bridge} path="7:0" addclass="" value={t('BUTTONS', 'DELETE_CUSTOMER')} />
        </div>
      )}
      {/* backButton */}
      <div {...backButton} className="CPushButton backbutton">
        <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined"></p>
      </div>
      {/* contentText und priceText ZULETZT - Legacy haengt sie per reDraw()
          ans Ende (s. Kopfkommentar). */}
      <Caption bridge={bridge} path="4" addclass="contenttext" value={bridge.state.content}
               style={contentStyle} />
      <Caption bridge={bridge} path="5" addclass="pricetext" value={bridge.state.price}
               style={priceStyle} />
    </>
  );
}

export const CCustomerDataMode = defineReactScreen({
  className: 'CCustomerDataMode',
  addclass: 'CCustomerDataMode CashWindow',
  htmlType: 'div',
  Screen: CustomerDataModeScreen,
  initialState: { content: ' ', price: ' ', datenDa: false, mitBon: false },
  prepare(bridge) {
    bridge.Main = POS.sessions.getSessionComponent();

    bridge.state.mitBon = bridge.Main.BonManager.currentBonId != 0;

    bridge.properties.styles.visibility = 'visible';
  },
  methods: {
    // Aufrufer: CInfoIcons.customerData, direkt nach draw().
    drawCustomerData(bridge) {
      // SQL-Text ZEICHENGENAU wie im Legacy (Master/Slave-Routing).
      var sql = 'SELECT * FROM CUST WHERE CUST_ID = ' + bridge.customerId;
      var r = POS.SQLiteCon.execute(sql);
      $.when(r).then(function (rows) {
        if (rows.length < 1) {
          return;
        }

        var dbFirstName = rows[0].FirstName;
        var dbSurname = rows[0].Surname;
        var dbAddress = rows[0].Address;
        var dbZIP = rows[0].ZIP;
        var dbCity = rows[0].City;
        var dbBarcode = rows[0].Barcode;

        var text = bridge.t('LABELS', 'CUSTOMER_NUMBER') + ':<br><br>';
        text += bridge.t('LABELS', 'NAME') + ':<br><br>';
        text += bridge.t('LABELS', 'ADDRESS') + ':<br><br>';
        text += bridge.t('LABELS', 'ZIP') + ' / ' +
          bridge.t('LABELS', 'CITY') + ':';

        var werte = dbBarcode + '<br><br>';
        werte += dbFirstName + ' ' + dbSurname + '<br><br>';
        werte += dbAddress + '<br><br>';
        werte += dbZIP + ' ' + dbCity;

        bridge.update({ content: text, price: werte, datenDa: true });
      });
    },
    // "Kunde zuruecknehmen" (nur ohne laufenden Bon).
    cancelCustomer(bridge) {
      bridge.Main.BonManager.currentCustomerId = 0;
      bridge.Main.InfoIcons.hideIcon('customer');

      bridge.removeMe();
    },
    cancel(bridge) {
      bridge.Main.InfoIcons.customerDataOn = false;

      bridge.removeMe();
    },
  },
});
